

































import { Component, Prop } from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';
import Avatar from '@/components/common/Avatar.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { CheckIcon } from 'vue-feather-icons';
import { IGoal } from 'admiral-core';

@Component({
  components: { Multiselect, Avatar, CheckIcon },
})
export default class Goal extends mixins(BaseMixin) {
  @Prop({ type: Boolean, default: () => false })
  multiple!: boolean;

  @Prop()
  goal!: IGoal | IGoal[];

  @Prop()
  selectableGoals!: IGoal | IGoal[];

  updateGoal(goal: IGoal | IGoal[]) {
    this.$emit('update-goal', goal);
  }

  isSelected(id: string) {
    if (Array.isArray(this.goal)) {
      return this.goal.find((goal: IGoal) => goal.id === id);
    } else {
      return this.goal.id === id;
    }
  }
}
